const colors = {
  pending: 'bg-yellow-100 text-yellow-800',
  confirmed: 'bg-blue-100 text-blue-800',
  color_match: 'bg-purple-100 text-purple-800',
  scheduled: 'bg-indigo-100 text-indigo-800',
  in_progress: 'bg-orange-100 text-orange-800',
  completed: 'bg-green-100 text-green-800',
  cancelled: 'bg-red-100 text-red-800',
  rescheduled: 'bg-gray-100 text-gray-800',
  // Color match statuses
  not_needed: 'bg-gray-100 text-gray-600',
  sent: 'bg-blue-100 text-blue-800',
  received: 'bg-green-100 text-green-800',
  unavailable: 'bg-red-100 text-red-800',
};

export default function StatusBadge({ status }) {
  const label = (status || '').replace(/_/g, ' ');
  return (
    <span className={`inline-block px-2 py-0.5 rounded-full text-xs font-medium capitalize ${colors[status] || 'bg-gray-100 text-gray-800'}`}>
      {label}
    </span>
  );
}
